'use client';

import dynamic from 'next/dynamic';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import HireProcess from '@/components/technologies/hire-process';
import CmsServies from '@/components/technologies/cms-demand';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));

const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="Improve Your Business Conversion and Retention Rates with a Top-Notch Custom Content management system (CMS) Development Company!"
                alt="hero image"
                title="hero image"
                width={588}
                height={550}
                path={'cms-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                CMS Development Services
            </TechHeroApp>
            <DefaultBreadcrumb parentPage="Services" isParent={true} currentPage="CMS Development" />

            <ContetVideoSection title="Address Your Content Management System Needs with Flexible and Structured CMS Development Services!">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        Appropriate for a wide range of development needs, CMS is a front-end user interface that allows business
                        owners to manage user-centered content in the most flexible and modular way. Being adapted to quickly
                        respond to changing market demands, the latest content management system frameworks like Drupal, Joomla,
                        WordPress, and DotNetNuke is highly used to build extensive and scalable business solution.
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        So, whether it&apos;s application development, theme development, custom web development services, CMS
                        migration, or support and maintenance, Moweb - A leading website development company leverages the power
                        of multiple frameworks to cater to your business needs in the utmost manner.
                    </p>
                </>
            </ContetVideoSection>
            <CmsServies />
            <HireProcess
                white={true}
                bg="bg-primary"
                pageTitle="Hire CMS Development To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using Vue.js."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For CMS Development?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best CMS Developers"
                desc="Select from different engagement models to hire CMS Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
